import {Pipe, PipeTransform} from '@angular/core';
import {LocalDto} from '../../Models/Local/local.interface';

@Pipe({
  name: 'locals',
  standalone: false,
})
export class LocalsPipe implements PipeTransform {

  transform(items: LocalDto[], forceLocals?: number[]): LocalDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (forceLocals && forceLocals.length > 0) {
      items = items.filter((item) => forceLocals?.includes(item.id));
    }

    return items;
  }

}
